<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import axios from "axios";
import Swal from "sweetalert2";
import $ from "jquery";

export default {
  page: {
    title: "Edit User",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Edit User",
      items: [
        {
          text: "Master",
          href: "/",
        },
        {
          text: "User",
          href: "/master/user",
        },
        {
          text: "Edit User",
          active: true,
        },
      ],
      // Catch Error Axios
      axiosCatchError: null,

      // variable Page
      id: this.$route.params.id,
      user_username: null,
      user_password: null,
      user_password_confirm: null,
      user_name: null,
      user_photo: null,
      photo_default: null,
      photo_full: null,
      list_role: [],
      selected_role: [],
    };
  },
  mounted() {
    let self = this;
    Swal.fire({
      title: '<i class="fas fa-spinner fa-spin"></i>',
      text: "Loading...",
      showConfirmButton: false,
      allowOutsideClick: false,
    });

    // get list role
    var config_list_role = {
      method: "get",
      url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/role-active",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.access_token,
      },
    };
    axios(config_list_role)
      .then(function (response) {
        var response_data = response.data;
        var response_data_fix = response_data.data;
        if (response_data.meta.code == 200) {
          self.list_role = response.data.data.referensi;
        } else {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response_data_fix.data.message,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });

    // get data user
    var config = {
      method: "get",
      url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/user",
      params: {
        id: self.id,
      },
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.access_token,
      },
    };
    axios(config)
      .then(function (response) {
        var response_data = response.data;
        var response_data_fix = response_data.data[0];
        if (response_data.meta.code == 200) {
          var data_edit = response_data_fix;

          self.user_username = data_edit.username;
          self.user_name = data_edit.name;
          self.photo_default = data_edit.path_photo;
          self.photo_full =
            process.env.VUE_APP_BACKEND_URL + data_edit.path_photo;
          self.selected_role = JSON.parse(data_edit.selected_role);
          Swal.close();
        } else {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response_data_fix.data.message,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
        Swal.close();
      });
  },
  methods: {
    StoreData() {
      let self = this;
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
      });

      var config_store_data = {
        method: "put",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/user",
        data: {
          id: self.id,
          username: self.user_username,
          password: self.user_password,
          password_confirm: self.user_password_confirm,
          name: self.user_name,
          path_photo: self.user_photo,
          selected_role: JSON.stringify(self.selected_role),
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config_store_data)
        .then(function (response) {
          console.log(response);
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "Anda akan diarahkan ke halaman master user segera",
            timer: 2000,
            timerProgressBar: true,
            showCancelButton: false,
            showConfirmButton: false,
          }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
              Swal.close();
              self.$router.push({ name: "all-user" });
            }
          });
        })
        .catch(function (error) {
          self.axiosCatchError = error.response.data.data;
          Swal.close();
        });
    },
    inputFilePhoto() {
      let self = this;
      if ($("#formPhoto")[0].files[0]) {
        if ($("#formPhoto")[0].files[0].size < 2242880) {
          $("#uploadLoading").html(
            '<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>'
          );
          var urlres = process.env.VUE_APP_BACKEND_URL;
          var FormData = require("form-data");
          var data = new FormData();
          data.append("file", $("#formPhoto")[0].files[0]);
          var config = {
            method: "post",
            url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
            data: data,
          };
          axios(config).then(function (response) {
            console.log(response.data.data.path_file);
            var path_file = response.data.data.path_file;
            urlres += path_file;
            $("#uploadLoading").html(
              '<span class="badge bg-success p-1"><i class="fa fa-check"></i> Berhasil </span> <a href="' +
                urlres +
                '" target="_blank" style="padding-left:10px;"><span class="badge bg-success p-1"><i class="fa fa-eye"></i> Lihat File</span></a>'
            );
            self.user_photo = path_file;
          });
        } else {
          alert("Max File 2 MB");
        }
      }
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <b-form class="p-2" @submit.prevent="StoreData">
            <div class="card-body">
              <div v-if="axiosCatchError">
                <div
                  class="alert alert-danger"
                  v-if="
                    typeof axiosCatchError === 'string' ||
                    axiosCatchError instanceof String
                  "
                >
                  {{ axiosCatchError }}
                </div>
                <div class="alert alert-danger" role="alert" v-else>
                  <div v-for="(errorArray, idx) in axiosCatchError" :key="idx">
                    <div v-for="(allErrors, idx) in errorArray" :key="idx">
                      <span class="text-danger">{{ allErrors[0] }} </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <b-form-group
                    class="mb-3"
                    label="Username"
                    label-for="formrow-username-input"
                  >
                    <b-form-input
                      id="formrow-username-input"
                      placeholder="Masukkan Username..."
                      type="text"
                      v-model="user_username"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-12">
                  <b-form-group
                    class="mb-3"
                    label="Password"
                    label-for="formrow-password-input"
                  >
                    <b-form-input
                      id="formrow-password-input"
                      placeholder="Masukkan Password..."
                      type="password"
                      v-model="user_password"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-12">
                  <b-form-group
                    class="mb-3"
                    label="Konfirmasi Password"
                    label-for="formrow-konfirmasi-password-input"
                  >
                    <b-form-input
                      id="formrow-konfirmasi-password-input"
                      placeholder="Masukkan Konfirmasi Password..."
                      type="password"
                      v-model="user_password_confirm"
                    ></b-form-input>
                  </b-form-group>
                  <hr />
                </div>
                <div class="col-md-12">
                  <b-form-group
                    class="mb-3"
                    label="Nama"
                    label-for="formrow-nama-input"
                  >
                    <b-form-input
                      id="formrow-nama-input"
                      placeholder="Masukkan Nama..."
                      type="text"
                      v-model="user_name"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-12">
                  <div class="mb-3">
                    <label for="formPhoto" class="form-label"
                      >Foto profil anda saat ini</label
                    >
                    <div v-if="photo_default == null">
                      <div class="position-relative">
                        <img
                          src="@/assets/images/users/avatar-9.png"
                          alt=""
                          class="img-thumbnail"
                          style="width: 350px"
                        />
                      </div>
                    </div>
                    <div v-else>
                      <div class="position-relative">
                        <img
                          v-bind:src="photo_full"
                          alt=""
                          class="img-thumbnail"
                          style="width: 350px"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-3">
                    <label for="formPhoto" class="form-label">Pilih Foto</label>
                    <input
                      class="form-control"
                      type="file"
                      id="formPhoto"
                      v-on:change="inputFilePhoto()"
                    />
                    <div
                      class="respond-input-file float-left"
                      id="uploadLoading"
                    ></div>
                    <small class="float-right" style="color: red"
                      >*) Max File 2 MB</small
                    >
                  </div>
                  <hr />
                </div>
                <div class="col-md-12">
                  <div class="mt-0">
                    <h5 class="font-size-14">
                      <i class="mdi mdi-arrow-right text-primary me-1"></i>
                      Pilih Role
                    </h5>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <div
                        v-for="(row_data, key_data) in list_role"
                        :key="key_data"
                      >
                        <div class="form-check-primary mb-3">
                          <b-form-checkbox
                            :value="row_data.id_role"
                            :unchecked-value="row_data.id_role"
                            v-model="selected_role"
                          >
                            {{ row_data.role_name }}
                          </b-form-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="row">
                <div class="col-md-6">
                  <div class="text-start">
                    <router-link
                      :to="{ name: 'all-user' }"
                      class="btn btn-warning"
                      ><i class="fa fa-arrow-left"></i> Kembali</router-link
                    >
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="text-end">
                    <b-button type="reset" variant="danger"
                      ><i class="fa fa-redo-alt"></i> Reset</b-button
                    >
                    &nbsp;
                    <b-button type="submit" variant="primary"
                      ><i class="fa fa-save"></i> Simpan</b-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </Layout>
</template>
